import { CDN_URL } from '@utils/constants/url.constants';
import React from 'react';

const NotAvailableState = () => {
  return (
    <div className={'absolute w-[250px] h-[130px] top-[9px] left-[20px]'}>
      <div className={'relative w-full h-full overflow-hidden'}>
        <img
          src={`${CDN_URL}assets/images/progress/notavailable.svg`}
          className={'w-full'}
          alt={''}
        />
        <div
          className={
            'absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 text-neutral-whiteboard'
          }
        >
          Not available
        </div>
      </div>
    </div>
  );
};

export default NotAvailableState;
